import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from 'src/app/core/toast.service';

@Component({
  selector: 'app-add-newsfeed-category',
  templateUrl: './add-newsfeed-category.component.html',
  styleUrls: ['./add-newsfeed-category.component.scss']
})
export class AddNewsfeedCategoryComponent implements OnInit {
  categoryForm: FormGroup;
  categoryId: string | null = null;
  categoryName: any;
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, public feedService: FeedService, public loginService: LoginService,private toast: ToastService) {
    this.categoryForm = this.fb.group({
      category_name: ['', Validators.required],
    });
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (params['categoryName']) {
        this.categoryForm.patchValue({ category_name: params['categoryName'] });
      }
    });
    this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('id');
      if (this.categoryId) {
        this.loadCategoryDetails();
      }
    });

  }
  loadCategoryDetails() { }

  onSubmit(): void {

    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();  // This will show error messages
      return;  
    }

    const loginData = this.loginService.getLoginData();


    if (!loginData) {
      console.error('Login data is not available');
      return;
    }
    const categoryData = {
      ...this.categoryForm.value,
      created_by: loginData.type,
      created_by_user_id: loginData.id
    };
    const response = this.categoryId ? this.feedService.editNewsFeedCategory(this.categoryId, categoryData.category_name) : this.feedService.addCategories(categoryData);
    response
      .then(response => {
        this.router.navigate(['/profile/list-newsfeeds']);
        this.toast.openSnackBar(this.categoryId ? 'Category Updated successfully':'Category Added successfully'); 
      })
      .catch(error => {
        console.error("Error occurred:", error);
      });


  }

  onCancel(): void {
    this.router.navigate(['/profile/list-newsfeeds']);
  }
}